import { Controller } from "@hotwired/stimulus"
import CardFan from "../src/card_fan"

// จับไพ่ 3 ใบ — การจิ้มบนจอเป็นแค่ละคร ค่าไพ่จริงสุ่มจาก server ตอน POST (ล็อกทั้งวัน กันโกง/รีเฟรช)
// กรีดไพ่เลือกเอง (Lek สั่ง 2 ส.ค. 69 แทนกริดคว่ำ 12 ช่อง): ปัดพัดหาใบที่ถูกใจ → แตะใบกลางลงช่อง
// → ครบ 3 กด "เริ่มทำนาย" → ยิง draw → เขียนหน้าไพ่ลงช่อง → flip ทีละใบ → พาไปหน้าผล
// ยังไม่กดเริ่มทำนาย = แตะช่องคืนไพ่กลับพัดได้ (เลือกผิดไม่ต้องรีเฟรชหน้า)
export default class extends Controller {
  static targets = ["slot", "status", "go"]
  static values = {
    url: String,
    category: String,
    ref: String,
    texts: Object, // ข้อความสถานะตามภาษาของหน้า (cards_page.pick) — %{count} แทนด้วยจำนวนใบ
    names: Object, // map รหัสไพ่ → ชื่อดาว (ส่งจาก server จะได้ไม่ต้อง hardcode ซ้ำ)
    colors: Object, // map รหัสไพ่ → คลาสสีประจำดาว (CardReadingHelper::PLANET_COLORS) ใช้กับแสงเรืองตอนพลิก
    arts: Object // map รหัสไพ่ → url รูปหน้าไพ่ (ค่าตั้งต้น — ของจริงรายวง server ส่งมากับ draw)
  }

  connect() {
    this.picked = [] // [{ card: ใบในพัด, slot: ช่องที่ลงไป }] เรียงตามลำดับที่เลือก
    this.locked = false
    this.fan = new CardFan(this.element.querySelector(".card-fan"), { onPick: (card) => this.take(card) })
  }

  disconnect() {
    this.fan?.destroy()
  }

  // แตะใบกลางพัด → ลงช่องว่างช่องถัดไป
  take(card) {
    if (this.locked || this.picked.length >= 3) return

    this.picked.push({ card, slot: this.slotTargets[this.picked.length] })
    this.fan.take(card)
    this.sync()
  }

  // แตะช่องที่มีไพ่อยู่ = คืนใบนั้นกลับพัด แล้วรูดใบที่เหลือมาชิดช่องซ้าย
  // (ไม่งั้นจะเหลือช่องว่างคั่นกลาง ดูเหมือนระบบค้าง)
  unpick(event) {
    if (this.locked) return

    const at = this.picked.findIndex((entry) => entry.slot === event.currentTarget)
    if (at < 0) return

    this.fan.release(this.picked[at].card)
    this.picked.splice(at, 1)
    this.picked = this.picked.map((entry, i) => ({ card: entry.card, slot: this.slotTargets[i] }))
    this.sync()
  }

  sync() {
    this.slotTargets.forEach((slot, i) => slot.classList.toggle("is-filled", i < this.picked.length))
    this.statusTarget.textContent = this.picked.length >= 3
      ? this.textsValue.full
      : this.textsValue.picked.replace("%{count}", this.picked.length)
    this.goTarget.disabled = this.picked.length < 3
  }

  confirm() {
    if (this.locked || this.picked.length < 3) return

    this.locked = true
    this.fan.lock()
    this.goTarget.disabled = true
    this.statusTarget.textContent = this.textsValue.opening
    this.draw()
  }

  async draw() {
    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({ category: this.categoryValue, ref: this.refValue })
      })
      if (!response.ok) throw new Error(`draw failed: ${response.status}`)
      const { cards, arts, result_url } = await response.json()
      this.reveal(cards, arts, result_url)
    } catch (error) {
      // ยิงไม่ผ่าน (เน็ตหลุด ฯลฯ) — ปลดล็อกให้กดใหม่ได้ ไพ่ที่เลือกไว้ยังอยู่ครบ ไม่ต้องเลือกใหม่
      this.locked = false
      this.fan.lock(false)
      this.goTarget.disabled = false
      this.statusTarget.textContent = this.textsValue.failed
    }
  }

  // arts = url รูปรายใบที่ server เลือกสำรับมาแล้ว (สองสำรับ ดาวเดียวกันคนละภาพ) —
  // ต้องใช้ตัวนี้ ไม่ใช่ artsValue ไม่งั้นไพ่ที่พลิกกับไพ่ในหน้าผลเป็นคนละภาพ
  async reveal(cards, arts, resultUrl) {
    const artOf = (i) => (arts && arts[i]) || this.artsValue[cards[i]]
    // โหลดรูปให้เสร็จก่อนพลิก ไม่งั้นไพ่จะหงายมาเป็นใบเปล่าแล้วรูปค่อยเด้งตามทีหลัง
    await this.preloadArt(cards, artOf)

    this.picked.forEach((entry, i) => {
      const code = cards[i]
      const art = artOf(i)
      const card = entry.slot.querySelector(".flip-card")
      card.querySelector("[data-card-glyph]").textContent = code
      card.querySelector("[data-card-name]").textContent = this.namesValue[code] || ""
      // ติดคลาสสีประจำดาวที่ตัวใบ → ขอบ/แสงเรืองเปลี่ยนเป็นสีดาวใบนั้นตอนหงาย
      const color = this.colorsValue[code]
      if (color) card.classList.add(color)

      if (art) {
        const image = card.querySelector("[data-card-art]")
        image.src = art
        image.alt = this.namesValue[code] || ""
        image.hidden = false
        card.querySelector("[data-card-front]").classList.add("has-art")
      }

      setTimeout(() => card.classList.add("is-flipped"), 400 + i * 250)
    })
    this.statusTarget.textContent = ""
    // พักให้ดูไพ่ครบก่อนค่อยพาไปอ่านคำทำนาย
    setTimeout(() => {
      if (window.Turbo) { window.Turbo.visit(resultUrl) } else { window.location = resultUrl }
    }, 400 + 3 * 250 + 1200)
  }

  // รอรูปครบ แต่ไม่เกิน 2.5 วิ — เน็ตช้าก็ต้องได้พลิกไพ่ ไม่ใช่ค้างหน้าจอ
  preloadArt(cards, artOf) {
    const urls = cards.map((_, i) => artOf(i)).filter(Boolean)
    if (urls.length === 0) return Promise.resolve()

    const loaded = Promise.all(urls.map((url) => new Promise((resolve) => {
      const image = new Image()
      image.onload = resolve
      image.onerror = resolve
      image.src = url
    })))
    return Promise.race([loaded, new Promise((resolve) => setTimeout(resolve, 2500))])
  }
}
